import { NOA_ORG } from "../static/organisation"
import { Role } from "../types/user"
import { getOrgUrlFromUuid } from "./utils"

export const isSupervisor = (roles: Role[] | undefined, orgUrl?: string) => {
  if (!roles) return false
  return !!roles.find(
    (r) =>
      (typeof r === "object" &&
        ["supervisor", "admin"].includes(r.role) &&
        (!orgUrl || [orgUrl, getOrgUrlFromUuid(NOA_ORG)].includes(r.organization))) ||
      (typeof r === "string" && ["supervisor", "admin"].includes(r)),
  )
}

export const isAdmin = (roles: Role[] | undefined, orgUrl?: string) => {
  if (!roles) return false
  return !!roles.find(
    (r) =>
      (typeof r === "object" &&
        ["admin"].includes(r.role) &&
        (!orgUrl || [orgUrl, getOrgUrlFromUuid(NOA_ORG)].includes(r.organization))) ||
      (typeof r === "string" && ["admin"].includes(r)),
  )
}
